import { FC, useCallback } from 'react';
import clsx from 'clsx';
import { IconButton } from '@mui/material';

import { DeviationQuestionUserResponseDto } from 'src/generated/services/TFinancialApi';
import { formatDateString } from 'src/utils/date';
import IconEdit from 'src/assets/images/icons/edit-2.svg';
import { IApprovalResultsProps } from './types';

export const ApprovalResults: FC<IApprovalResultsProps> = (props) => {
  const { title, answers, className, moreActions, onClickEdit } = props;

  const getAnswerValue = useCallback((answer: DeviationQuestionUserResponseDto) => {
    if (answer?.questionType === 'DATE_RANGE') {
      const dates = JSON.parse(answer?.answerText);
      if (dates?.start && dates?.end) {
        return (
          <div className='flex items-center max-w-[480px]'>
            <div className='w-1/2'>
              <h3 className='text-14 xl:text-16 mb-4'>Start:</h3>

              {formatDateString(dates.start)}
            </div>
            <div className='w-1/2'>
              <h3 className='text-14 xl:text-16 mb-4'>End:</h3>
              {formatDateString(dates.end)}
            </div>
          </div>
        );
      }
      return '-';
    }
    return answer?.answerText || answer?.answerName;
  }, []);

  if (answers?.length < 1) {
    return null;
  }

  return (
    <div className={clsx('mb-20 xl:mb-24', className)}>
      <div className='border-t border-neutral-20 pt-20 px-7'>
        <div className='flex items-center mb-20'>
          <h3 className='text-14 xl:text-16 leading-18 xl:leading-20 font-bold'>{title}</h3>
          <div className='ml-auto flex items-center gap-12'>
            <>{moreActions}</>
            {onClickEdit && (
              <IconButton onClick={onClickEdit}>
                <img src={IconEdit} alt='' className='w-20 xl:w-24' />
              </IconButton>
            )}
          </div>
        </div>

        {answers?.length > 0 ? (
          <div className='flex flex-col gap-12'>
            <div className='relative'>
              {answers.map((answer) => (
                <div
                  key={`answer-${answer?.answerOptionId}`}
                  className='mb-22 pb-16 border-b border-dashed border-neutral-20 last:mb-0 last:pb-0 last:border-0'
                >
                  <div className='mb-10'>
                    <span className='text-14 xl:text-16 leading-16 xl:leading-18 text-blue_grey-30'>{answer?.questionName}</span>
                  </div>
                  {/* Hide answer text for charge selection questions since it's shown in the table below */}
                  {answer?.questionDomainType !== 'SELECT_A_CHARGE_NAME' && <div className='text-14 xl:text-16 leading-16'>{getAnswerValue(answer)}</div>}
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>No Data</p>
        )}
      </div>
    </div>
  );
};
